export async function performNativeTask() {
  throw new Error('Open this task on its owning Mac to manage it.');
}
export function nativeTaskResultsRoute() {
  throw new Error('Open this task on its owning Mac to view its chat.');
}
